module.exports = __webpack_public_path__ + "static/media/Money.823b09be.svg";